export default "__VITE_ASSET__BXFCXBH7__"